import React from 'react';
import { NextScreenConfiguration } from '@luckycart/xpn-types';

import { NextCtaButton, NextBackground, NextHtmlZone } from './NextScreen.style';
import { BlockInfoType } from '../../common-types/BlockInfo.type';

interface Props {
  config: NextScreenConfiguration;
  ctaOnClick?: React.MouseEventHandler<HTMLDivElement>;
  addEditableBlock?: (block: BlockInfoType) => void;
  isEdition?: boolean;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
}

export const NextScreen: React.FunctionComponent<Props> = ({ addEditableBlock, config, ctaOnClick, isEdition, onBlockEdit } : Props) => {
  return (
    <NextBackground
      displayName="Background"
      sizeInfo={{ height: 440, width: 1080 }}
      addEditableBlock={addEditableBlock}
      dataTemplateConfig="screens.next.background"
      backgroundImage={config.background.imageUrl}
      backgroundColor={config.background.color}
      isEdition={isEdition}
      onClick={onBlockEdit}
    >
      <NextHtmlZone
        displayName="HTML Zone"
        addEditableBlock={addEditableBlock}
        html={config.mainTextBox.html}
        dataTemplateConfig="screens.next.mainTextBox"
        isEdition={isEdition}
        onClick={onBlockEdit}
      />
      <NextCtaButton
        displayName="CTA"
        addEditableBlock={addEditableBlock}
        backgroundColor={config.ctaButton.background.color}
        innerHTML={config.ctaButton.html}
        onClick={
          onBlockEdit === undefined
            ? ctaOnClick
            : onBlockEdit
        }
        dataTemplateConfig="screens.next.ctaButton"
        isEdition={isEdition}
      />
    </NextBackground>
  );
};
